import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { buildYearOptions } from '../../utils/executive-pulse-reporting-period.js';

export default function ReportingPeriodSelector({ year, onChange }) {
    const options = useMemo(() => buildYearOptions(new Date(), 8, 1), []);

    return (
        <div className="exec-pulse-period-selector">
            <label
                htmlFor="exec-pulse-reporting-year"
                className="exec-pulse-period-label">
                Year
            </label>
            <select
                id="exec-pulse-reporting-year"
                className="exec-pulse-period-select"
                value={String(year)}
                onChange={(e) => {
                    onChange(Number.parseInt(e.target.value, 10));
                }}>
                {options.map((o) => (
                    <option key={o.year} value={String(o.year)}>
                        {o.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

ReportingPeriodSelector.propTypes = {
    year: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
};
